import React from 'react';
import {Controller, useForm} from 'react-hook-form';
import ReactModal from "react-modal";
import ReactSelect from "react-select";
import {Color, getColorSelectOptions} from "../../../../enum/label/Color";
import {FormValidationType, makeRegisterOptions} from "../../../../libs/reactHookForm/makeRegisterOptions";

interface LabelFormModalProps {
  isEdit: boolean;
  defaultValues: LabelFormValues;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  onSave: (label: LabelFormValues) => Promise<void>;
  onSaved: () => Promise<void>;
}

export interface LabelFormValues {
  name: string;
  color: Color;
}

export const LabelFormModal = (props: LabelFormModalProps) => {
  const { isEdit, defaultValues, setShowModal, onSave, onSaved} = props;

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues,
    reValidateMode: 'onSubmit',
  });

  const onSubmit = async (data: LabelFormValues): Promise<void> => {
    await onSave(data);
    await onSaved();
  }

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => setShowModal(false)}
        className="form-modal"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
      >
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">ラベル{ isEdit ? '編集' : '作成' }</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
          </div>
          <form>
            <div className="form-modal-content">
              <div className="w-full">
                <div className="mb-4 text-danger text-xs">

                  { (Object.keys(errors).length > 0) && '入力エラーがあります' }
                </div>

                { /* 名前 */ }
                <div className="mb-4">
                  <label htmlFor="menuName">
                    <div className="text-xs font-semibold text-primary mb-1">
                      <span>名前</span>
                      <span className="ml-2 required">必須</span>
                    </div>

                    <input
                      /* eslint-disable-next-line react/jsx-props-no-spreading */
                      {...register('name',
                        makeRegisterOptions('名前', [
                          { type: FormValidationType.REQUIRED },
                          { type: FormValidationType.MAX_STRING_LENGTH, value: 100 },
                        ])
                      )}
                      id="name"
                      type="text"
                      className="text-field"
                      maxLength={100}
                    />
                    <div className="mt-1 text-danger text-xs">
                      {errors.name?.message}
                    </div>
                  </label>
                </div>

                { /* 色 */ }
                <div className="mb-4">
                  <label htmlFor="color">
                    <div className="text-xs font-semibold text-primary mb-1">
                      <span>色</span>
                      <span className="ml-2 required">必須</span>
                    </div>
                    <Controller
                      name="color"
                      control={control}
                      render={({field}) =>
                        (
                          <ReactSelect
                            className="w-full text-xs"
                            menuPlacement="auto"
                            options={getColorSelectOptions()}
                            value={getColorSelectOptions().find(option => option.value === field.value)}
                            onChange={async (option) => { await field.onChange(option?.value); }}
                          />
                        )
                      }
                      rules={
                        makeRegisterOptions('色', [
                          { type: FormValidationType.REQUIRED },
                        ])
                      }
                    />
                    <div className="mt-1 text-danger text-xs">
                      {errors.color?.message}
                    </div>
                  </label>
                </div>

              </div>
              <div className="form-modal-footer-container">
                <div className="form-modal-footer">
                  <button
                    className="btn-sub"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    キャンセル
                  </button>
                  <button
                    className="btn-primary"
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                  >
                    保 存
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ReactModal>
    </>
  );
};